import React from "react";

function RepostIconWhite() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.503"
      height="18"
      viewBox="0 0 10.503 18"
    >
      <g
        id="Group_26861"
        data-name="Group 26861"
        transform="translate(-12271.271 2246)"
      >
        <path
          id="Path_18878"
          data-name="Path 18878"
          d="M5,8.211v6H6.313V9.544h6.677L10.4,12.176l.928.942L15.5,8.877,11.325,4.636l-.928.942,2.593,2.632Z"
          transform="translate(12266.271 -2250.636)"
          fill="#fff"
        />
        <path
          id="Path_18882"
          data-name="Path 18882"
          d="M15.5,10.634v-6H14.189V9.3H7.513l2.593-2.632-.928-.942L5,9.967l4.177,4.241.928-.942L7.513,10.634Z"
          transform="translate(12266.271 -2242.208)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default RepostIconWhite;
